import { ITypedReduxAction } from '../../../../packages/redux-utils';

export enum EModalActionTypes {
  ModalOpen = 'modal/open',
  ModalClose = 'modal/close',
}

export type TModalOpen = ITypedReduxAction<EModalActionTypes.ModalOpen>;
export type TModalClose = ITypedReduxAction<EModalActionTypes.ModalClose>;

export type TModalActions = TModalOpen | TModalClose;
